import React, { useState } from 'react';
import TicketList from '../components/Inbox/TicketList';
import Cockpit from '../components/Inbox/Cockpit';
import ContextPanel from '../components/Inbox/ContextPanel';
import { initialTickets } from '../data/mockData';

export default function InboxView() {
  const [tickets, setTickets] = useState(initialTickets);
  const [activeTicketId, setActiveTicketId] = useState(initialTickets[0].id);

  const activeTicket = tickets.find(t => t.id === activeTicketId);

  const handleReply = (ticketId, text) => {
    setTickets(prev => prev.map(t => {
      if (t.id === ticketId) {
        return {
          ...t,
          messages: [
            ...t.messages,
            { id: Date.now(), sender: 'agent', text, timestamp: new Date().toISOString() }
          ],
          status: 'pending' // Auto switch status on reply
        };
      }
      return t;
    }));
  };

  return (
    <div className="flex h-full w-full overflow-hidden">
      <TicketList 
        tickets={tickets} 
        activeTicketId={activeTicketId} 
        onSelectTicket={setActiveTicketId} 
      />
      <Cockpit 
        ticket={activeTicket} 
        onReply={handleReply} 
      />
      <ContextPanel 
        ticket={activeTicket} 
      />
    </div>
  );
}